import { getMappedLanguage } from 'i18n/helpers';
import { InitAssistantParameters } from './types';
import { ASSISTANT_ENDPOINT } from './constants';

export const validateInitAssistantParams = (
  parameters: InitAssistantParameters,
) => {
  if (!parameters?.assistant) {
    return new Error(
      'Missing one or more of the required properties: assistant',
    );
  }

  return undefined;
};

export const makeInitAssistantEndpoint = (
  parameters: InitAssistantParameters,
) => {
  const { lang } = parameters;

  const mappedLang = getMappedLanguage(lang);

  let endpoint = ASSISTANT_ENDPOINT;

  if (mappedLang) {
    endpoint = `${endpoint}?lang=${mappedLang}`;
  }

  return endpoint as typeof ASSISTANT_ENDPOINT;
};

export const assistantStore = new Map();
